import enLang from "./entries/en_US";
import jaLang from "./entries/ja_JP";

const AppLocale = {
  en: enLang,
  ja: jaLang,
};

export default AppLocale;
